import {themeGetter, useTheme} from 'quickstart/styled-components/system'

export const useThemeGetter = () => themeGetter(useTheme())
